import { PhoneNumberUtil } from 'google-libphonenumber';

export const PHONE_REGEX = /(\d{2})(\d)(\d{2})(\d{2})(\d{2})(\d)/g;

export const phoneDecorator = (phone) => {
  if (!phone) return;

  let formattedPhone = phone;
  formattedPhone = formattedPhone.replaceAll(' ', ''); // remove spaces
  formattedPhone = formattedPhone.replace(PHONE_REGEX, '$1 $2 $3 $4 $5 $6');

  return formattedPhone;
};

export const isPhoneValid = (value) => {
  if (value === '+33') return true;
  const phoneUtil = PhoneNumberUtil.getInstance();

  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
  } catch (error) {
    return false;
  }
};
